"use strict";

exports.__esModule = true;
exports.StyledTooltip = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledTooltip = (0, _styledComponents.default)(_reactTooltip.default)`
    max-width: 250px;
    padding: ${props => props.theme.space[4]};
    font-size: ${props => props.theme.fontSizes[3]};
    white-space: initial;
    &.show {
        opacity: 1 !important;
    }
`;
exports.StyledTooltip = StyledTooltip;